// Utility functions for PDF operations

export const renderPage = (pageId, pathWithoutExt, canvasRef, stateData) => {
  const canvas = canvasRef.current;
  console.log('Rendering page:', pageId, 'from path:', pathWithoutExt);
  if (!canvas) {
    console.error('Canvas element not found');
    return;
  }

  const ctx = canvas.getContext('2d');
  
  // Get container dimensions
  const container = canvas.parentElement.parentElement;
  const containerWidth = container.clientWidth - 40;
  const containerHeight = container.clientHeight - 40;
  
  // Set initial canvas size for loading state (fit to container)
  canvas.width = Math.max(640, containerWidth);
  canvas.height = Math.max(800, containerHeight);
  
  // Show loading state
  ctx.fillStyle = '#f5f5f5';
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = '#666';
  ctx.font = '16px Arial';
  ctx.textAlign = 'center';
  ctx.fillText(`Loading page ${pageId + 1}...`, canvas.width / 2, canvas.height / 2);

  const img = new Image();
  
  const pngPath = `${pathWithoutExt.replace('.pdf', '')}-${pageId}.png`;
  img.src = `/api/png/${pngPath}`;
  console.log('Loading image:', img.src);
  
  img.onload = () => {
    const dpr = window.devicePixelRatio || 1;
    const fitScale = Math.min(containerWidth / img.width, containerHeight / img.height, 1);
    const drawWidth = img.width * fitScale;
    const drawHeight = img.height * fitScale;

    canvas.width = Math.round(drawWidth * dpr);
    canvas.height = Math.round(drawHeight * dpr);
    canvas.style.width = `${Math.round(drawWidth)}px`;
    canvas.style.height = `${Math.round(drawHeight)}px`;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    const offsetX = 0;
    const offsetY = 0;

    ctx.drawImage(img, 0, 0, img.width, img.height, offsetX, offsetY, drawWidth, drawHeight);
    stateData.displayWidth = drawWidth;
    stateData.displayHeight = drawHeight;

    if (stateData.redactions[pageId]) {
      ctx.fillStyle = 'rgba(0, 0, 0, 0.5)';
      stateData.redactions[pageId].forEach(redaction => {
        ctx.fillRect(
          redaction.x[0] * stateData.displayWidth,
          redaction.y[0] * stateData.displayHeight,
          (redaction.x[1] - redaction.x[0]) * stateData.displayWidth,
          (redaction.y[1] - redaction.y[0]) * stateData.displayHeight
        );
      });
    }
  };

  img.onerror = (error) => {
    console.error('Failed to load image:', error);
    ctx.fillStyle = '#fee';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = '#c00';
    ctx.font = '16px Arial';
    ctx.textAlign = 'center';
    ctx.fillText('Error loading page', canvas.width / 2, canvas.height / 2);
  };
};

export const getCanvasCoordinates = (event, canvasRef, stateData) => {
  const canvas = canvasRef.current;
  if (!canvas) return null;
  if (!Number.isFinite(stateData.displayWidth) || !Number.isFinite(stateData.displayHeight)) {
    console.warn('Display dimensions not ready yet; ignoring click.');
    return null;
  }

  const rect = canvas.getBoundingClientRect();
  const scaleX = 1;  // canvas.width / rect.width;
  const scaleY = 1;  // canvas.height / rect.height;


  // Get the current canvas coordinates
  const canvasX = (event.clientX - rect.left) * scaleX;
  const canvasY = (event.clientY - rect.top) * scaleY;

  var relX = Math.min(canvasX / stateData.displayWidth, 1);
  var relY = Math.min(canvasY / stateData.displayHeight, 1);

  
  return {
    x: relX,
    y: relY,
    // Store canvas dimensions for debugging
    // canvasWidth: canvas.width,
    // canvasHeight: canvas.height,
    // originalImageWidth: canvas.originalImageWidth,
    // originalImageHeight: canvas.originalImageHeight,
    // scaleFactor: canvas.scaleFactor
  };
};

export const drawRedactionBox = (start, end, overlayCanvasRef, mainCanvasRef, stateData, isPreview = false) => {
  const overlay = overlayCanvasRef.current;
  const mainCanvas = mainCanvasRef.current;
  if (!overlay || !mainCanvas) return;

  // Ensure overlay matches main canvas dimensions
  overlay.width = mainCanvas.width;
  overlay.height = mainCanvas.height;

  const ctx = overlay.getContext('2d');
  ctx.clearRect(0, 0, overlay.width, overlay.height);

  const x = Math.min(start.x, end.x);
  const y = Math.min(start.y, end.y);
  const width = Math.abs(end.x - start.x);
  const height = Math.abs(end.y - start.y);

  // Draw semi-transparent fill
  ctx.fillStyle = isPreview ? 'rgba(0, 0, 0, 0.2)' : 'rgba(0, 0, 0, 0.5)';
  ctx.fillRect(x * stateData.displayWidth, y * stateData.displayHeight,
    width * stateData.displayWidth, height * stateData.displayHeight);

  // Draw border
  ctx.strokeStyle = '#4285f4';
  ctx.lineWidth = 2;
  ctx.strokeRect(
    x * stateData.displayWidth,
    y * stateData.displayHeight,
    width * stateData.displayWidth,
    height * stateData.displayHeight
  );

  return { x: [x, x + width], y: [y, y + height] };
}; 
